/*
 * @Descripttion: Box 封装
 * @version:
 * @Author: 周志国
 * @Date: 2025-09-08
 * @LastEditors: 周志国
 * @LastEditTime: 2025-09-15 10:48:13
 * @changeLog: 实现立方体对象，支持默认参数、更新与销毁
 * @FilePath: /anov-3d-webgl/packages/anov-3d-ability/src/business/Sphere/index.ts
 */
import type { MeshBasicMaterialParameters } from '@anov/3d-core'
import {
  Mesh,
  MeshBasicMaterial,
  type SceneControl,
  SphereGeometry,
} from '@anov/3d-core'
import _ from 'lodash'
import ObjectLayer from '../Base/ObjectLayer'
import { defineProps } from '../Utils/defineProps'
import type { options } from './types'
import type { ISphere } from './interface'

export class Sphere extends ObjectLayer implements ISphere {
  private mesh!: Mesh
  private currentOptions!: options
  constructor(options: options, sceneControl: SceneControl) {
    super(sceneControl)
    this.currentOptions = options
    this.mesh = this.createSphere(options)
    this.add(this.mesh)
    defineProps(
      this,
      ['radius', 'sphereSegments'],
      ['wireframe', 'color'],
      'updateSphere',
    )
  }

  createSphere(options: options): Mesh {
    const {
      radius = 1,
      sphereSegments = 16,
      material = {},
    } = options

    const defaultMat: MeshBasicMaterialParameters = {
      color: 0xFFFFFF,
      opacity: 1,
      transparent: false,
      wireframe: false,
      visible: true,
    }
    const geometry = new SphereGeometry(radius, sphereSegments, sphereSegments)
    geometry.translate(0, radius, 0)
    const mat = new MeshBasicMaterial({ ...defaultMat, ...material })
    return new Mesh(geometry, mat)
  }

  updateSphere(options: options): void {
    if (!this.mesh)
      return
    _.mergeWith(this.currentOptions, options)
    this.remove(this.mesh)
    this.mesh.geometry.dispose();
    (this.mesh.material as any).dispose()
    this.mesh = this.createSphere(this.currentOptions)
    this.add(this.mesh)
  }

  /** 销毁释放资源 */
  public destroy() {
    if (!this.mesh)
      return
    this.remove(this.mesh)
    this.mesh.geometry.dispose()
    ; (this.mesh.material as any).dispose()
    // @ts-ignore
    this.mesh = null
  }
}
